import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("h2", { style: {"font-size":"20px"} }, " Entry employer ", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"36px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_segment, {
              mode: "ios",
              modelValue: _ctx.selectedMode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMode) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, "1. Segment(s)")
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  value: 2,
                  disabled: _ctx.employerOptions.length == 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, "2. Employer(s)")
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_segment_button, {
                  value: 3,
                  disabled: _ctx.chosenEmployers.length == 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, "3. Prioritize (" + _toDisplayString(_ctx.chosenEmployers.length) + ")", 1)
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("p", null, "(Drag & move)", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_searchbar, {
              style: {"padding-top":"15px"},
              mode: "ios",
              modelValue: _ctx.searchKeyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchKeyword) = $event)),
              placeholder: _ctx.t('search'),
              onIonFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSearching = true)),
              onIonBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSearching = false)),
              onKeyup: _cache[5] || (_cache[5] = _withKeys((e) => e.target.blur(), ["enter"]))
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.selectedMode == 2]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentOptions, (segment) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  key: segment.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_checkbox, {
                      justify: "start",
                      labelPlacement: "end",
                      "onUpdate:modelValue": ($event: any) => (_ctx.onCheckSegment($event, segment)),
                      modelValue: _ctx.chosenSegments.find(s => s.id == segment.id) != null
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(segment.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onUpdate:modelValue", "modelValue"]),
                    _createVNode(_component_ion_button, {
                      onClick: ($event: any) => (_ctx.openSegmentModal(segment)),
                      color: "medium",
                      slot: "end",
                      fill: "clear",
                      size: "small",
                      style: {"margin-inline-end":"16px","text-transform":"none"}
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode(" More ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.selectedMode == 1]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employerOptions, (employer) => {
                return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                  key: employer.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_checkbox, {
                      justify: "start",
                      labelPlacement: "end",
                      "onUpdate:modelValue": ($event: any) => (_ctx.onCheckEmployer($event, employer)),
                      modelValue: _ctx.chosenEmployers.find(s => s.id == employer.id) != null
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(employer.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onUpdate:modelValue", "modelValue"]),
                    _withDirectives(_createVNode(_component_ion_button, {
                      href: employer.company_url,
                      target: "_blank",
                      color: "medium",
                      slot: "end",
                      fill: "clear",
                      size: "small",
                      style: {"margin-inline-end":"16px","text-transform":"none"}
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode(" More ")
                      ])),
                      _: 2
                    }, 1032, ["href"]), [
                      [_vShow, employer.company_url]
                    ])
                  ]),
                  _: 2
                }, 1024)), [
                  [_vShow, !_ctx.searchKeyword || employer.name.toLowerCase().includes(_ctx.searchKeyword.toLowerCase().trim())]
                ])
              }), 128))
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.selectedMode == 2]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_ion_reorder_group, {
            onIonItemReorder: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doReorder($event, _ctx.chosenEmployers))),
            disabled: false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenEmployers, (segment, idx) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  lines: "full",
                  key: idx,
                  style: {"--min-height":"55px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_reorder, {
                      mode: "ios",
                      slot: "start"
                    }),
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(idx+1) + ". " + _toDisplayString(segment.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_buttons, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _withModifiers(($event: any) => (_ctx.chosenEmployers.splice(idx, 1)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.trashOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { class: "ion-margin-bottom" }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createElementVNode("p", null, "I am an ideal candidate for them because...", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_textarea, {
                    class: "ion-margin-bottom",
                    label: "Claim 1",
                    "label-placement": "floating",
                    fill: "outline",
                    "auto-grow": true,
                    modelValue: _ctx.data.claim1,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.claim1) = $event)),
                    placeholder: "Reason for hiring me / Claim 1"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ion_textarea, {
                    class: "ion-margin-bottom",
                    label: "Claim 2",
                    "label-placement": "floating",
                    fill: "outline",
                    "auto-grow": true,
                    modelValue: _ctx.data.claim2,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.claim2) = $event)),
                    placeholder: "Reason for hiring me / Claim 2"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ion_textarea, {
                    label: "Claim 3",
                    "label-placement": "floating",
                    fill: "outline",
                    "auto-grow": true,
                    modelValue: _ctx.data.claim3,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.claim3) = $event)),
                    placeholder: "Reason for hiring me / Claim 3"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.chosenEmployers.length > 0]
          ])
        ], 512), [
          [_vShow, _ctx.selectedMode == 3]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_col, { size: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      color: "dark",
                      fill: "clear",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedMode--))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.arrowBack
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.selectedMode > 1]
                ]),
                _withDirectives(_createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onClickNext())),
                      disabled: _ctx.isNextDisabled()
                    }, {
                      default: _withCtx(() => [
                        _cache[20] || (_cache[20] = _createTextVNode(" Next ")),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.arrowForward
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.selectedMode < 3]
                ]),
                _withDirectives(_createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      color: "success",
                      expand: "block",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.confirmSelect()))
                    }, {
                      default: _withCtx(() => [
                        _cache[21] || (_cache[21] = _createTextVNode(" Done ")),
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.checkmark
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.selectedMode >= 3]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}